import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Element } from 'react-scroll';
import SliderComponent from 'react-slick';

import { media } from '@theme/media';
import { NARROW_CONTAINER_WIDTH, SIDEBAR_WIDTH } from '@components/blocks';
import { slickStyles } from '@components/common/slick.styles';
import { COLORS } from '@theme/colors';
import { OFFSET } from '@theme/helpers';

const hideElement = ({ hide }: { hide: boolean }) => (hide ? 'none' : 'block');

export const Container = styled.div`
  display: none;
  ${media.tablet} {
    display: block;
  }
  ${media.desktop} {
    padding-left: ${SIDEBAR_WIDTH}px;
  }
`;

export const Figure = styled.figure`
  box-sizing: border-box;
  margin: 0;
  padding: 88px 26px 0;

  ${media.tablet} {
    margin: 0;
    padding: 68px 26px 0;
    height: calc(100vh - 34px * 2);
  }
`;

export const MotionImage = styled(motion.img)<{ hide: boolean }>`
  object-fit: contain;
  width: 100%;
  height: 100%;
  transform-origin: center;
  display: ${hideElement};
`;

export const SliderWrapper = styled.div`
  ${media.tablet} {
    display: none;
  }
  position: relative;
  ${slickStyles};
  .slick-track {
    display: flex;
    align-items: center;
  }

  .slick-slide {
    display: flex;
    justify-content: center;
    margin: 0 1px;
  }
`;

const sliderNavigationGap = '6px';

export const Slider = styled(SliderComponent)<{ height?: number }>`
  height: 100%;
  position: relative;

  .slick-list,
  .slick-track,
  .slick-slide {
    height: 100%;
  }

  figure {
    min-height: 180px;
  }

  .slick-slide {
    img {
      min-height: 180px;
      height: ${({ height }) => height && `${height}px`};
    }
  }

  .slick-cloned {
    pointer-events: none;
  }

  .slick-dots {
    transition: transform 0.2s ease-in-out;
    bottom: -82px;
    width: calc(100% - 20px);
    max-width: 100%;
    left: 10px;
    display: flex !important;
    margin: 0;
    z-index: 1;
    gap: ${sliderNavigationGap};

    ${media.tablet} {
      width: ${NARROW_CONTAINER_WIDTH}px;
      left: calc(50% - ${NARROW_CONTAINER_WIDTH}px / 2);
    }

    li {
      width: auto;
      flex-grow: 1;
      height: 25px;
      position: relative;
      margin: 0;

      &.slick-active button:before {
        background-color: ${COLORS.ALTO};
        opacity: 1;
      }

      button {
        width: 100%;
        height: 100%;
        padding: 0;

        &:before {
          content: '';
          width: 100%;
          height: 2px;
          margin: ${OFFSET.XS} 0;
          display: block;
          opacity: 1;
          background-color: ${COLORS.ALTO};
        }

        &:focus-visible {
          outline: auto;
          outline-color: blue;
        }

        &:hover,
        &:focus {
          &:before {
            opacity: 1;
            background-color: ${COLORS.ALTO};
          }
        }
      }
    }
  }
`;

export const SliderScrollBar = styled.div`
  transition: transform 0.2s ease-in-out;
  position: absolute;
  bottom: -70px;
  width: calc(100% - 20px);
  max-width: 100%;
  left: 10px;
  margin: 0;
  height: 2px;
  padding: 0;
  z-index: 1;
  pointer-events: none;

  ${media.tablet} {
    width: ${NARROW_CONTAINER_WIDTH}px;
    left: calc(50% - ${NARROW_CONTAINER_WIDTH}px / 2);
  }
`;

export const Thumb = styled.div<{ slidersCount: number; index: number }>`
  height: 100%;
  width: ${({ slidersCount }) =>
    slidersCount ? `calc((100% - (${slidersCount - 1} * ${sliderNavigationGap})) / ${slidersCount})` : 0};
  position: relative;
  background-color: ${COLORS.BLACK};
  transition: transform 0.6s;
  transform: translate3d(${({ index }) => (index ? `calc((100% + ${sliderNavigationGap}) * ${index})` : 0)}, 0, 0);

  ${media.tablet} {
    width: ${({ slidersCount }) => (slidersCount ? `calc(${NARROW_CONTAINER_WIDTH}px / ${slidersCount})` : 0)};
    transform: translate3d(
      ${({ index, slidersCount }) => (index ? `calc(${NARROW_CONTAINER_WIDTH}px / ${slidersCount} * ${index})` : 0)},
      0,
      0
    );
  }
`;

export const ScrollElement = styled(Element)`
  display: flex;
  justify-content: center;

  &:first-child figure {
    height: calc(100vh - 44px * 2);
    margin-bottom: 26px;
  }

  &:not(:first-child) figure {
    padding: 0;
    margin-top: 74px;
    margin-bottom: 26px;

    ${media.tablet} {
      margin-bottom: 0;
      padding: 68px 26px 0;
    }
  }
`;

export const ImageButton = styled.button<{ isSpaceView: boolean; hide: boolean }>`
  margin: 0 auto;
  padding: 0;
  pointer-events: ${({ isSpaceView }) => (isSpaceView ? 'none' : 'auto')};
  display: ${hideElement};
`;

export const SpaceViewButtonWrapper = styled.div`
  display: block;

  ${media.mobile} {
    margin-bottom: 0;
  }

  ${media.tablet} {
    display: none;
  }
`;

export const MobileSpaceViewButtonContainer = styled.div`
  // position: absolute;
  // left: 50%;
  // bottom: -50px;
  // transform: translateX(-50%);
  z-index: 1;
  margin: 130px 0 0;

  button {
    width: 245px;
    margin: 0 auto;
  }

  ${media.tablet} {
    display: none;
  }
`;
